let accessTokenMemory: string | null = null;

export function getStoredAccessToken(): string | null {
  return accessTokenMemory;
}

export function setStoredAccessToken(token: string): void {
  accessTokenMemory = token || null;
}

export function clearStoredAccessToken(): void {
  accessTokenMemory = null;
}
